import React from 'react';
import {classNames} from 'utils';

interface IAvatarProps {
  imageUrl?: string | null;
  fallback?: string;
  alt?: string;
  size?: 'small' | 'normal' | 'large';
}

const Avatar = ({imageUrl, fallback, alt, size = 'normal'}: IAvatarProps) => {
  const sizes = {
    small: {
      container: 'size-12',
      text: 'text-lg',
    },
    normal: {
      container: 'size-16',
      text: 'text-2xl',
    },
    large: {
      container: 'size-24',
      text: 'text-4xl',
    },
  };
  const commonClassName = classNames('object-cover rounded-full shrink-0', sizes[size].container);
  if (imageUrl) {
    return <img src={imageUrl} alt={alt} className={commonClassName} />;
  }
  return (
    <div className={classNames(commonClassName, 'bg-primary flex items-center justify-center')}>
      {!!fallback && <p className={classNames('text-white font-semibold', sizes[size].text)}>{fallback}</p>}
    </div>
  );
};

export default React.memo(Avatar);
